import React, { useEffect, useMemo, useState } from "react";
import { Modal } from "../UI";
import { paymentsService } from "../../api/services/paymentsService";

const MIN_AMOUNT_BY_CURRENCY = {
    KZT: 10,
};

const isAddPaymentSuccess = (result) => {
    if (!result || !Array.isArray(result.object) || result.object.length < 2) {
        return false;
    }
    const codeOk =
        Number(result.code) === 200 || result.code === "200";
    const statusOk =
        typeof result.status === "string" &&
        result.status.toLowerCase() === "success";
    return codeOk || statusOk;
};

const ShopPayModal = ({ isOpen, onClose }) => {
    const [currency, setCurrency] = useState("RUB");
    const [amount, setAmount] = useState("");
    const [courses, setCourses] = useState([]);
    const [submitting, setSubmitting] = useState(false);
    const [submitError, setSubmitError] = useState(null);

    useEffect(() => {
        if (!isOpen) {
            return;
        }

        setSubmitError(null);

        const getCourses = async () => {
            try {
                const result = await paymentsService.getCourses();
                setCourses(result || []);
            } catch (error) {
                console.error(error);
            }
        };
        getCourses();
    }, [isOpen]);

    const totalPrice = useMemo(() => {
        const parsedAmount = Number(amount);
        if (!parsedAmount) {
            return "";
        }

        const currentCourse = courses.find(
            (item) => item.currency === currency,
        );
        if (!currentCourse?.donateCoins) {
            return "";
        }

        return (parsedAmount / currentCourse.donateCoins).toFixed(2);
    }, [amount, courses, currency]);

    const minAmount = MIN_AMOUNT_BY_CURRENCY[currency] || 1;
    const parsedAmount = Number(amount || 0);
    const isAmountValid = parsedAmount >= minAmount;

    const handleAmountChange = (event) => {
        const digitsOnly = event.target.value.replace(/\D/g, "");
        setAmount(digitsOnly === "0" ? "" : digitsOnly);
    };

    const submitPayment = async (event) => {
        event.preventDefault();
        if (!isAmountValid || !amount) {
            return;
        }

        const formData = new FormData(event.currentTarget);
        const payload = Object.fromEntries(formData.entries());

        try {
            setSubmitting(true);
            setSubmitError(null);
            const result = await paymentsService.addPayment(payload);
            if (isAddPaymentSuccess(result)) {
                const [signature, orderAmount] = result.object;
                const q = new URLSearchParams({
                    m: "56847",
                    oa: String(orderAmount),
                    currency: String(payload.money_currency),
                    o: String(payload.target_user),
                    s: String(signature),
                });
                window.location.href = `https://pay.fk.money/?${q.toString()}`;
            } else {
                setSubmitError(
                    "Не удалось получить ссылку на оплату. Попробуйте позже.",
                );
            }
        } catch (err) {
            console.error("Ошибка загрузки данных:", err.message);
            setSubmitError(err.message || "Ошибка запроса. Попробуйте позже.");
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} className="modal--shop-pay">
            <div className="modal-content-container shop-pay-modal">
                <span className="modal-title">СПОСОБЫ ОПЛАТЫ</span>

                <form className="shop-pay-form" onSubmit={submitPayment}>
                    <input
                        className="auth-input-form"
                        type="text"
                        name="target_user"
                        placeholder="Логин"
                        minLength={3}
                        required
                    />

                    <select
                        className="shop-pay-select"
                        name="money_currency"
                        value={currency}
                        onChange={(e) => setCurrency(e.target.value)}
                    >
                        <option value="RUB">RUB</option>
                        <option value="USD">USD</option>
                        <option value="EUR">EUR</option>
                        <option value="UAH">UAH</option>
                        <option value="KZT">KZT</option>
                    </select>

                    <input
                        className="auth-input-form"
                        name="donate_coins"
                        type="text"
                        placeholder="Количество MD коинов"
                        value={amount}
                        onChange={handleAmountChange}
                        required
                    />

                    <div className="shop-pay-summary">
                        СУММА: {totalPrice} {totalPrice ? currency : ""}
                    </div>

                    {!isAmountValid && amount && (
                        <div className="shop-pay-error">
                            Минимальная сумма для {currency}: {minAmount}
                        </div>
                    )}

                    {submitError && (
                        <div className="shop-pay-error">{submitError}</div>
                    )}

                    <div className="modal-buttons">
                        <button
                            className={`shop-primary-button has-inline-loader ${
                                submitting ? "is-loading" : ""
                            }`}
                            type="submit"
                            disabled={!isAmountValid || !amount || submitting}
                            aria-busy={submitting}
                            style={{ flexGrow: 1 }}
                        >
                            <span className="inline-loader__label">ПОПОЛНИТЬ</span>
                            {submitting ? (
                                <span
                                    className="btn__loader inline-loader"
                                    aria-label="Загрузка"
                                >
                                    <span className="btn__loader-dot"></span>
                                    <span className="btn__loader-dot"></span>
                                    <span className="btn__loader-dot"></span>
                                </span>
                            ) : null}
                        </button>
                        <button
                            className="shop-secondary-button"
                            type="button"
                            onClick={onClose}
                            style={{ flexGrow: 1 }}
                        >
                            ОТМЕНА
                        </button>
                    </div>
                </form>
            </div>
        </Modal>
    );
};

export default ShopPayModal;
